/**
 * @generated SignedSource<<9f3d23d020934b93d62f270656ede141>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraProjectListRightPanelState = "CLOSED" | "OPEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton$data = {
  readonly canCreateProject: boolean | null | undefined;
  readonly shouldDisplay?: boolean | null | undefined;
  readonly sidebarExperimentTemplates: {
    readonly totalCount: number;
  };
  readonly userPreferences: {
    readonly __id: string;
    readonly projectListRightPanelState: JiraProjectListRightPanelState | null | undefined;
  };
  readonly " $fragmentType": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton";
};
export type openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton$key = {
  readonly " $data"?: openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton$data;
  readonly " $fragmentSpreads": FragmentRefs<"openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton",
  "selections": [
    {
      "alias": "canCreateProject",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "type",
          "value": "CREATE_PROJECT"
        }
      ],
      "kind": "ScalarField",
      "name": "canPerform"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shouldDisplay",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "VIEW_PROJECT_CREATION_ENTRY"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          (v0/*: any*/)
        ],
        "concreteType": "JiraUserPreferences",
        "kind": "LinkedField",
        "name": "userPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "projectListRightPanelState"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "userPreferences"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "sidebarExperimentTemplates",
        "args": [
          (v0/*: any*/),
          {
            "kind": "Literal",
            "name": "experimentKey",
            "value": "sidebarExperiment"
          }
        ],
        "concreteType": "JiraProjectListViewTemplateConnection",
        "kind": "LinkedField",
        "name": "projectListViewTemplates",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "totalCount"
            },
            "action": "THROW",
            "path": "sidebarExperimentTemplates.totalCount"
          }
        ]
      },
      "action": "THROW",
      "path": "sidebarExperimentTemplates"
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "e48c036460980f3b260084bce6706d60";

export default node;
